import { createFileRoute, notFound } from "@tanstack/react-router";
import { MarkdownArticle, getContentBySlug } from "~/components/content";
import { Shell } from "~/components/site-shell";
import { breadcrumbs, jsonLd, seoHead } from "~/config/seo";
export const Route = createFileRoute("/legal/$slug")({
  loader: ({ params }) => {
    const item = getContentBySlug("legal", params.slug);
    if (!item) throw notFound();
    return item;
  },
  head: ({ loaderData, params }) => ({
    ...seoHead({
      title: `${loaderData?.title ?? "Legal"} | HostRight`,
      description: loaderData?.description ?? "",
      path: `/legal/${params.slug}`,
      type: "article",
    }),
    scripts: loaderData
      ? [
          jsonLd(
            breadcrumbs([
              { name: "Home", path: "/" },
              { name: loaderData.title, path: `/legal/${params.slug}` },
            ]),
          ),
        ]
      : [],
  }),
  component: () => (
    <Shell>
      <MarkdownArticle item={Route.useLoaderData()} sidebar={false} />
    </Shell>
  ),
});
